import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/settlement_rules',
  component: Management,
  redirect: '/settlement_rules/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/settlement_rules/List'),
      redirect: 'list/all',
      meta: {
        auth: Auth.listSettlementRules
      },
      children: [
        {
          path: 'all',
          component: () => import('@/views/settlement_rules/ListTable'),
          meta: {
            auth: Auth.listSettlementRules,
            tabName: 'all'
          }
        },
        {
          path: 'settlement_rule_statistics',
          component: () => import('@/views/settlement_rules/SettlementRuleStatistics'),
          meta: {
            auth: Auth.listSettlementRules,
            tabName: 'settlement_rule_statistics'
          }
        }
      ]
    },
    // 新增
    {
      path: 'new',
      component: () => import('@/views/settlement_rules/New'),
      meta: {
        auth: Auth.createSettlementRule
      }
    },
    // 编辑
    {
      path: ':id/edit',
      component: () => import('@/views/settlement_rules/Edit'),
      meta: {
        auth: Auth.updateSettlementRule
      }
    },
    // 详情
    {
      path: ':id',
      component: () => import('@/views/settlement_rules/DetailLayout'),
      meta: {
        auth: Auth.showSettlementRule
      },
      children: [
        // 基本信息
        {
          path: 'detail',
          component: () => import('@/views/settlement_rules/details/Detail'),
          meta: {
            tabName: 'detail', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showSettlementRule
          }
        },
        // 电站结算
        {
          path: 'ev_charging_station_settlements',
          component: () => import('@/views/settlement_rules/details/EvChargingStationSettlements'),
          meta: {
            tabName: 'ev_charging_station_settlements', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showSettlementRule
          }
        },
        // 订单结算
        {
          path: 'order_settlements',
          component: () => import('@/views/settlement_rules/details/OrderSettlements'),
          meta: {
            tabName: 'order_settlements', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showSettlementRule
          }
        }
      ]
    }
  ]
}
